import {Injectable} from '@angular/core';
import {ShopProvider, ShopproviderService as API} from '../../generated/sales-terminal-client';
import {SnackService} from '../snack/snack.service';
import {Observable, tap} from 'rxjs';
import {PageableResult, ScrollLoadService} from '../../components/scroll-load-component/scroll-load.component';
import {ScrollLoad} from '../../components/scroll-load-component/ScrollLoad';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ShopProviderService implements ScrollLoadService<ShopProvider> {
  constructor(private _api: API,
              private snackService: SnackService) {}

  public search(data: any): Observable<PageableResult<ShopProvider>> {
    return this._api.searchShopProviders(
      data.tag,
      data.page,
      data.pageSize
    ).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    ) as Observable<PageableResult<ShopProvider>>;
  }
  public displayScrollLoadOption(option: ShopProvider): string {
    return '<b>' + option.tag + '</b>' + (option.name ? (' (' + option.name + ')') : '');
  }
  public displayScrollLoadSelection(selection: ShopProvider): string | undefined {
    if (!selection) { return ''; }
    return selection.tag + ' (' + selection.name + ')';
  }
  public getScrollLoad(pageSize?: number, idKey?: string): ScrollLoad<ShopProvider> {
    return new ScrollLoad<ShopProvider>(pageSize || 50, idKey || 'id', 'tag');
  }
  public getTotalElements(): Observable<number> {
    return this._api.searchShopProviders().pipe(
      tap({
        error: (e) => this.snackService.showBackendError(e)
      }),
      map((result: PageableResult<ShopProvider>) => result.total)
    );
  }
}
